// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sectionTitle":"css-1aqj8-CvSr"};